'use client';

import Link from 'next/link';
import { useState } from 'react';
import { Button } from '@/components/ui/button';

export default function RegisterPage() {
    const [clinicName, setClinicName] = useState('');
    const [ownerName, setOwnerName] = useState('');
    const [email, setEmail] = useState('');
    const [phone, setPhone] = useState('');
    const [submitted, setSubmitted] = useState(false);

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        setSubmitted(true);
    };

    if (submitted) {
        return (
            <div className="min-h-screen bg-[#0a0a1a] flex items-center justify-center px-6">
                <div className="max-w-md w-full text-center">
                    <div className="w-20 h-20 mx-auto mb-6 rounded-full bg-emerald-500/10 flex items-center justify-center">
                        <svg className="w-10 h-10 text-emerald-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                        </svg>
                    </div>
                    <h2 className="text-2xl font-bold text-white mb-3">Đăng ký thành công!</h2>
                    <p className="text-gray-400 mb-8">
                        Cảm ơn bạn đã đăng ký. Chúng tôi sẽ liên hệ trong vòng 24 giờ để thiết lập hệ thống cho phòng khám của bạn.
                    </p>
                    <Link
                        href="/"
                        className="inline-flex items-center gap-2 px-6 py-3 bg-gradient-to-r from-indigo-600 to-purple-600 rounded-xl font-medium text-white hover:from-indigo-500 hover:to-purple-500 transition-all"
                    >
                        <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
                        </svg>
                        Về trang chủ
                    </Link>
                </div>
            </div>
        );
    }

    return (
        <div className="min-h-screen bg-[#0a0a1a] text-white">
            <div className="fixed inset-0 z-0">
                <div className="absolute inset-0 bg-gradient-to-br from-indigo-950/80 via-[#0a0a1a] to-purple-950/60" />
                <div className="absolute top-1/4 left-1/3 w-[400px] h-[400px] bg-indigo-600/[0.08] rounded-full blur-[100px]" />
                <div className="absolute bottom-1/4 right-1/3 w-[300px] h-[300px] bg-purple-600/[0.08] rounded-full blur-[80px]" />
            </div>

            <nav className="relative z-10 flex items-center justify-between px-6 md:px-12 py-5 max-w-7xl mx-auto">
                <Link href="/" className="flex items-center gap-3">
                    <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-indigo-500 to-purple-600 flex items-center justify-center shadow-lg shadow-indigo-500/20">
                        <svg className="w-5 h-5 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19.428 15.428a2 2 0 00-1.022-.547l-2.387-.477a6 6 0 00-3.86.517l-.318.158a6 6 0 01-3.86.517L6.05 15.21a2 2 0 00-1.806.547M8 4h8l-1 1v5.172a2 2 0 00.586 1.414l5 5c1.26 1.26.367 3.414-1.415 3.414H4.828c-1.782 0-2.674-2.154-1.414-3.414l5-5A2 2 0 009 10.172V5L8 4z" />
                        </svg>
                    </div>
                    <span className="text-xl font-bold bg-gradient-to-r from-white to-gray-300 bg-clip-text text-transparent">
                        ClirxOS
                    </span>
                </Link>
                <Link href="/login" className="px-5 py-2.5 text-sm font-medium text-gray-300 hover:text-white transition-colors">
                    Đã có tài khoản? Đăng nhập
                </Link>
            </nav>

            <main className="relative z-10 max-w-lg mx-auto px-6 pt-8 pb-20">
                <div className="text-center mb-10">
                    <h1 className="text-3xl font-bold mb-3">Đăng ký dùng thử</h1>
                    <p className="text-gray-400">Thiết lập hệ thống cho phòng khám của bạn trong 5 phút</p>
                </div>

                <form onSubmit={handleSubmit} className="space-y-5">
                    <div className="p-8 rounded-2xl bg-white/[0.03] border border-white/[0.06] space-y-5">
                        <div>
                            <label className="block text-sm font-medium text-gray-300 mb-1.5">Tên phòng khám</label>
                            <input type="text" required value={clinicName} onChange={(e) => setClinicName(e.target.value)}
                                placeholder="VD: Phòng khám BS Nguyễn Văn A"
                                className="w-full px-4 py-3 bg-white/5 border border-white/10 rounded-xl text-white placeholder:text-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent transition-all" />
                        </div>
                        <div>
                            <label className="block text-sm font-medium text-gray-300 mb-1.5">Tên chủ phòng khám</label>
                            <input type="text" required value={ownerName} onChange={(e) => setOwnerName(e.target.value)}
                                placeholder="Họ và tên"
                                className="w-full px-4 py-3 bg-white/5 border border-white/10 rounded-xl text-white placeholder:text-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent transition-all" />
                        </div>
                        <div>
                            <label className="block text-sm font-medium text-gray-300 mb-1.5">Email</label>
                            <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
                                placeholder="email@example.com"
                                className="w-full px-4 py-3 bg-white/5 border border-white/10 rounded-xl text-white placeholder:text-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent transition-all" />
                        </div>
                        <div>
                            <label className="block text-sm font-medium text-gray-300 mb-1.5">Số điện thoại</label>
                            <input type="tel" required value={phone} onChange={(e) => setPhone(e.target.value)}
                                placeholder="0912 345 678"
                                className="w-full px-4 py-3 bg-white/5 border border-white/10 rounded-xl text-white placeholder:text-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent transition-all" />
                        </div>
                    </div>

                    <Button variant="ghost"   type="submit"
                        className="w-full py-4 text-base font-semibold bg-gradient-to-r from-indigo-600 to-purple-600 rounded-2xl hover:from-indigo-500 hover:to-purple-500 transition-all duration-300 shadow-2xl shadow-indigo-500/25 hover:shadow-indigo-500/40">
                        Đăng ký dùng thử miễn phí
                    </Button>

                    <p className="text-center text-xs text-gray-500 mt-4">
                        Bằng việc đăng ký, bạn đồng ý với{' '}
                        <a href="#" className="text-indigo-400 hover:underline">Điều khoản sử dụng</a>
                        {' '}và{' '}
                        <a href="#" className="text-indigo-400 hover:underline">Chính sách bảo mật</a>.
                    </p>
                </form>
            </main>
        </div>
    );
}
